import { useContext, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsCheckLg } from 'react-icons/bs';
import PropTypes from 'prop-types';

import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import ConditionalWrapper from '../../../../ConditionalWrapper/ConditionalWrapper';
import LoaderContext from '../../../../../context/LoaderProvider';
import useToast from '../../../../../hooks/useToast';
import './AcceptButton.scss';
import { ubicationTypeEnum } from '../../../../../utils/dataStatus';
import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import {
  getLocationProgramPointAdapter,
  obtainOperativeData
} from '../../../../../services/programPointsService';
import useLocationProgramPoints from '../../../../WorkReportModals/ProgramPointModal/useLocationProgramPoints';
import { getClasificationApprover } from '../../../../../services/workReport';

const AcceptButton = ({ dailyWorkReport, fetchData, selectedDate }) => {
  const [disabledButton, setDisabledButton] = useState(false);
  const { setNewToast } = useToast();
  const selectedDateFormated = new Date(selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setLoader } = useContext(LoaderContext);
  const { activeAcceptModal } = useWorkReportModals();

  const { approveLocationProgramPoints, approve, getLocationWithOperativeData } =
    useLocationProgramPoints({
      line: dailyWorkReport
    });

  const AcceptQuantity = async () => {
    try {
      setLoader(true);
      setDisabledButton(true);
      const isWellOrLocation =
        dailyWorkReport?.tipoUbicacionEnum === ubicationTypeEnum.pozo ||
        dailyWorkReport?.tipoUbicacionEnum === ubicationTypeEnum.locacion;

      if (!isWellOrLocation) {
        await approve(dailyWorkReport?.idParteDiario);
        fetchData();

        return;
      }

      const locations = await getLocationProgramPointAdapter(dailyWorkReport);
      const locationsWithOperativeData = await obtainOperativeData(dailyWorkReport?.idParteDiario);

      const clasificationForPhase = await getClasificationApprover(
        locationsWithOperativeData?.costoClase?.[0]?.fase,
        dailyWorkReport?.eventoSigla
      );

      const classificationSigla = clasificationForPhase?.[0]?.sigla;
      const costPhase = locationsWithOperativeData?.costoClase?.[0];

      const locationWithData = {
        ...locationsWithOperativeData,
        costoClase: [
          {
            combinacion: costPhase?.combinacion,
            costoClase: costPhase?.costoClase,
            fase: costPhase?.fase,
            nombre: costPhase?.costoClase?.split([' '])[0]
          }
        ],
        clasification: {
          nombre: classificationSigla,
          id: classificationSigla,
          label: classificationSigla,
          value: classificationSigla
        }
      };

      const newLocationsAdapter = getLocationWithOperativeData(locations, locationWithData);

      const hasOperativeData = newLocationsAdapter.some((location) =>
        location?.programPoints?.some(
          (pp) => pp?.code && pp?.subCode && pp?.detail && pp?.clasification && pp?.cost
        )
      );

      if (hasOperativeData) {
        await approveLocationProgramPoints(newLocationsAdapter);
        fetchData();

        return;
      }

      activeAcceptModal({
        daily: dailyWorkReport,
        fetchData,
        line: {
          positionName: dailyWorkReport?.posicionSap,
          lineName: dailyWorkReport?.lineaSap,
          idParteDiario: dailyWorkReport?.idParteDiario,
          estadoEnum: dailyWorkReport?.estadoEnum,
          tienePuntosPrograma: dailyWorkReport?.notificaPorPuntosPrograma,
          puntoPrograma: dailyWorkReport?.puntoPrograma,
          unidadMedida: dailyWorkReport?.unidadMedida,
          eventoSigla: dailyWorkReport?.eventoSigla,
          isApproval: true
        },
        editCSA: true,
        dateSelect: selectedDate
      });
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err?.message || 'Ha ocurrido un error al aprobar la solicitud.'
      });
    } finally {
      setDisabledButton(false);

      setLoader(false);
    }
  };

  return (
    <ConditionalWrapper
      condition={todayOlderThanSelectedDate}
      wrapper={(children) => (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={<Tooltip id="approve-approver">Linea con fecha posterior a la actual</Tooltip>}
          placement="top"
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div>
        <div className="action-button-container">
          <button
            aria-label="Aprobar"
            className="accept-button"
            disabled={disabledButton || todayOlderThanSelectedDate}
            onClick={AcceptQuantity}
            type="button"
          >
            <BsCheckLg size={12} />
          </button>
        </div>
      </div>
    </ConditionalWrapper>
  );
};

export default AcceptButton;

AcceptButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport,
  fetchData: PropTypes.func,
  selectedDate: PropTypes.string.isRequired
};

AcceptButton.defaultProps = {
  dailyWorkReport: {},
  fetchData: () => {}
};
